import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, DatePicker, Divider, Input, message, Modal, Select, Tabs, Row, Col, Tooltip, Image, Alert, Checkbox } from "antd";
import AuthService from "../../../Components/auth/AuthService";
import config from "../../../../src/Components/config";
import DeleteIcon from "@mui/icons-material/Delete";
import { BgColorsOutlined, DownloadOutlined, FieldTimeOutlined, ProductOutlined, SnippetsOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import qs from "query-string";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from "../../../context/loadingContext";
import { useNavigate, useParams } from "react-router-dom";
import { HelperReminderTasks } from "../../../Components/common/Constants";
import { showMessage } from "../../../Components/Utils/message";
import FormGrid from "../../../Components/common/FormGrid";
import InputBox from "../../../Components/common/InputBox";
import { decodeId } from "../../../Components/common/CommonFun";


const Auth = new AuthService();

const EditHelperReminder = () => {
  const { Option } = Select;
  const { TextArea } = Input;
  const navigate = useNavigate()
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  var layoutDispatch = useLoadingDispatch();

  const [selectedHelper, setSelectedHelper] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [taskStatus, setTaskStatus] = React.useState(null);
  const [notes, setNotes] = React.useState("");

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const [allHelpers, setAllHelpers] = React.useState([]);
  

  const getAllHelpers = async () => {
       showLoading(layoutDispatch);
       try {
         const response = await Auth.fetch(`/helper/warehouse-helpers`);
         if (response) {
           hideLoading(layoutDispatch);
           if (response?.ack) {
             setAllHelpers(response.warehouse_helpers);
           }
         }
       } catch (err) {
         console.log(err);
       }
     }

  useLayoutEffect(()=> {
    getAllHelpers()
  },[])


  const getDataByID = async () => {
    showLoading(layoutDispatch)
    try {
        const res = await Auth.fetch(`/warehouse-helper-reminder/reminder-warehouse-helper?id=${id}`)
        if(res?.ack) {
            setCurrentItemFiles(res?.reminder.files ? JSON.parse(res?.reminder.files) : [])
                setNotes(res?.reminder?.notes || '')
                setSelectedHelper(res?.reminder.warehouse_helper_id);
                setTaskStatus(res?.reminder.status)
                setSelectedTask(res?.reminder.type)
                setDueDate(res?.reminder.due_date ? dayjs(res?.reminder.due_date, 'YYYY-MM-DD') : null)
                
        }
    } catch (err) {
        console.log(err);
    } finally {
        hideLoading(layoutDispatch)
    }
  }



  useEffect(()=>{
    if(id > 0) {
        getDataByID()
    }
  },[])

  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(selectedHelper)) {
    showMessage('error','Please select vehicle')
    return;
    }
    if(isEmptyOrUndefined(selectedTask)) {
      showMessage('error','Please select service task')
      return;
    }
    if(isEmptyOrUndefined(dueDate)) {
      showMessage('error','Please select due date')
      return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      warehouse_helper_id : selectedHelper, 
      due_date: dueDate ? dayjs(dueDate).format("YYYY-MM-DD") : null,
      type:selectedTask,
      notes: notes,
      files: currentItemFiles,
      status: taskStatus,
      id: id
    }
    
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/reminder-warehouse-helper", {
        method: "PUT",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {
        console.log(res);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        navigate('/helper_reminder')
        showMessage('success',res?.message)
      } else {
        showMessage('error',res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.wms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/warehouse-reminders-helper/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };


  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  const formItems = [
     {
            label: "Helper",
            value: selectedHelper,
            options: allHelpers,
            onChange: (val) => setSelectedHelper(val ),
            icon: <ProductOutlined style={{ color: "#722ed1"}}/>,
            readOnly: true,
            type: 'select',
            data: 'helpers',
          },
          {
            label: "Tasks",
            value: selectedTask,
            options: HelperReminderTasks,
            onChange: (val) => setSelectedTask(val),
            icon: <ProductOutlined style={{ color: "#1677ff"}}/>,
            readOnly: true,
            type: 'select',
            data: 'constants',
          },
          {
            label: "Due Date",
            value: dueDate,
            onChange: (date) => { setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null) },
            icon: <FieldTimeOutlined style={{ color: "#1677ff"}}/>,
            readOnly: false,
            type: 'date',
            data: 'constants',
            disabledDate: disabledDate
          },
          
  ]

  const notesItem = {
            label: 'Notes',
            value: notes,
            onChange: (val) => setNotes(val),
            type: 'notes',
            icon: <SnippetsOutlined  style={{ color: "#1677ff"}}/>
    };

  return (
    <>
      <div>
      <div>
            <h3>Edit Helper Reminder</h3>
        </div>
        <FormGrid formItems={formItems} />
        <>
        <>
        {/* <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Helper<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedHelper}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedHelper(value);
              }}
            >
              {allHelpers.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.first_name}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Tasks<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedTask(value);
              }}
            >
              {HelperReminderTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"DD-MM-YYYY"}
              value={dueDate}
              onChange={(date) => {
                setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              disabledDate={disabledDate}
            />
            </Col>
          </Row> */}
          <Row style={{ marginTop: '10px', marginBottom: '10px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <Checkbox
              checked={taskStatus === 0} 
              onChange={(e) => setTaskStatus(e.target.checked ? 0 : 2)}
              style={{ transform: "scale(1.5)", marginLeft: '25px' }} 
              
            >
              Inactive
            </Checkbox>
          </Col>
        </Row>
          <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            {/* <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} /> */}
                <InputBox inputItem={notesItem} inputType={'notes'}/>
            </Col>
          </Row>
        </>
        
        <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                    
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            showMessage('error',"A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.wms_uploads_cdn}/${config.env}/warehouse-reminders-helper/${id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
      
        <Divider />
      {files?.length > 0 && <h4>Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>            
          </>
        </>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/helper_reminder")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleOk}
            >
              Save
            </Button>
        </div>
          
      </div>
    </>
  );
};

export default EditHelperReminder;
